const formatFilterValuesParameters = (parameters) => {
  const { qMap, ...filter } = parameters.filter || {};
  return {
    ...parameters,
    filter: {
      ...filter
    }
  };
};
export {
  formatFilterValuesParameters
};
